import styled from 'styled-components'
import { Tokens } from '@/assets/tokens'

export const KeyMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  min-height: 0;
`

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  background-color: ${Tokens.ColorWhite};
  border-radius: 12px;
  border: 1px solid ${Tokens.ColorBorder};
`

export const FormTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
`

export const KeyMessageFormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: none;
  min-height: 0;
  overflow: visible;
`

export const KeyMessageTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
  margin: 0;
  flex-shrink: 0;
`

export const KeyMessageTitleWithCounter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const KeyMessageTextArea = styled.textarea`
  width: 100%;
  min-height: 120px;
  max-height: 200px;
  padding: 12px;
  border: 1px solid #dee2ef;
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  resize: vertical;
  overflow-y: auto;

  &:focus {
    outline: none;
    border-color: #01c38d;
  }

  &::placeholder {
    color: #9ca3af;
  }
`

export const KeyMessageCountSpan = styled.span`
  font-size: 12px;
  color: #666;
`

export const TableSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  border-radius: ${Tokens.RadiusInput};
  background-color: ${Tokens.ColorWhite};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`

export const KeyMessageFiltersContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`

export const PremisesPreview = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  width: 100%;
  overflow: hidden;
  min-width: 0;
  max-height: 60px;
  flex: 1 1 0;
`

export const PremiseTag = styled.span`
  padding: 4px 8px;
  background-color: ${Tokens.ColorUIPrimaryLight};
  color: ${Tokens.ColorTextPrimary};
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 0 1 auto;
  min-width: 0;
  max-width: 100%;
`

export const MessageCell = styled.div`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  color: ${Tokens.ColorTextSecondary};
`

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
`

export const AddButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
`

export const FavorabilityToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
  padding: 16px 0;
`

export const FavorabilityDescription = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${Tokens.ColorTextPrimary};
  line-height: 1.4;
  font-weight: 400;
`

export const Advice = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${Tokens.ColorUIDanger};
`

export const BrandAndSourceRow = styled.div`
  display: grid;
  grid-template-columns: minmax(260px, 340px) 1fr;
  gap: 16px;
  align-items: end;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`

export const BrandSelectorContainer = styled.div`
  width: 100%;
  max-width: 340px;
`

export const ApplyToContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  min-height: 48px;
  padding-bottom: 2px;
  flex-wrap: wrap;
`
